import { useStoreState } from 'easy-peasy';
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from '../../services/axios.js';
import ActivitiesCard from './ActivitiesCard.jsx';
import Loader from '../widgets/Loader.jsx';
import PropTypes from 'prop-types';

import './ActivitiesPanel.scss';

const ActivitiesNumbers = (props) => {

    const { clientsUniqueId = [], setIsFetching, isFetching, oneMonth, datesFilter, fromStatsPage = false } = props;

    const [activity, setActivity] = useState(0);

    const { apiData: { URLs } } = useStoreState(state => state.actionSlugs);

    const postUrl = URLs?.getActivityNumbers?.url;

    const timeoutDelay = fromStatsPage ? 1000 : 0;

    const isFirstRender = useRef(true);

    const updateData = () => {
        axios.post(postUrl, { uuid: clientsUniqueId, oneMonth, startDate: datesFilter?.[0], endDate: datesFilter?.[1] }, { responseType: "json" })
            .then((response) => {
                setActivity(response);
            }).finally(() => setIsFetching(false));
    }

    useEffect(() => {
        if (clientsUniqueId?.length > 0 && !isFetching) {
            const timeoutId = setTimeout(() => {
                setIsFetching(true);
                updateData();
            }, timeoutDelay);

            return () => clearTimeout(timeoutId);
        } else {
            setActivity(0);
        }
    }, [clientsUniqueId]);


    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (clientsUniqueId?.length > 0 && !isFetching) {
            setIsFetching(true);
            updateData();
        } else {
            setActivity(0);
        }
    }, [oneMonth, datesFilter]);

    return (
        isFetching ?
            <Loader />
            :
            <div className="welcome-card numbers-banner">
                <h1>Usages {!!oneMonth && " sur les 30 derniers jours"}</h1>
                    <Row>
                        <Col>
                            <ActivitiesCard
                            activityName='Casques utilisés'
                            activityData={activity.activeHeadset !== null && activity.activeHeadset !== undefined
                                ? activity.activeHeadset
                                : '-'}
                            key='activeHeadset'
                            />
                    </Col>

                    <Col>
                        <ActivitiesCard
                            activityName='Expériences immersives vues casques'
                            activityData={activity.viewsXP?.headsetViews !== null && activity.viewsXP?.headsetViews !== undefined
                                ? activity.viewsXP?.headsetViews
                                : '-'}
                            key='headsetViews'
                        />
                        </Col>

                        <Col>
                            <ActivitiesCard
                            activityName='Expériences immersives vues webapp'
                            activityData={activity.viewsXP?.webapp2Views !== null && activity.viewsXP?.webapp2Views !== undefined
                                ? activity.viewsXP?.webapp2Views
                                : '-'}
                            key='webapp2Views'
                            />
                        </Col>

                        <Col>
                            <ActivitiesCard
                            activityName='Stories vues'
                            activityData={activity.webappViews !== null && activity.webappViews !== undefined
                                ? activity.webappViews
                                : '-'}
                            key='webappStoryViews'
                            />
                        </Col>
                    </Row>
            </div>
    )
}

ActivitiesNumbers.propTypes = {
    clientsUniqueId: PropTypes.array,
    setIsFetching: PropTypes.func,
    isFetching: PropTypes.bool,
    oneMonth: PropTypes.bool,
    datesFilter: PropTypes.array,
    fromStatsPage: PropTypes.bool
};

export default ActivitiesNumbers;